import "react-toastify/dist/ReactToastify.css";
import "./app.scss";
import { Routes, Route } from "react-router-dom";
import AdminLayout from "./layouts/AdminLayout";
import PublicLayout from "./layouts/PublicLayout";
import HomePage from "./pages/Home/HomePage";
import SignupPage from "./pages/User/SignupPage";
import DashboardPage from "./pages/Dashboard/DashboardPage";
import UsersPage from "./pages/User/UsersPage";
import NotFoudPage from "./pages/404/NotFoudPage";
import CreateUserPage from "./pages/User/CreateUserPage";
import UserProfilePage from "./pages/User/UserProfilePage";

import UpdateUserPage from "./pages/User/UpdateUserPage";

import { AuthProvider } from "./contexts/AuthContext";

import LoginPage from "./pages/Home/LoginPage";
import CreateCandidaturePage from "./pages/Candidature/CreateCandidaturePage";
import CompetitorDashboardPage from "./pages/Dashboard/CompetitorDashboardPage";
import ViewCandidaturePage from "./pages/Candidature/ViewCandidaturePage";
import UpdateCandidaturePage from "./pages/Candidature/UpdateCandidaturePage";
import ListCandidaturesPage from "./pages/Candidature/ListCandidaturesPage";
import SubmittedCandidaturePage from "./pages/Candidature/SubmittedCandidaturePage";
import CreateSelfKnowledgeQuestionnairePage from "./pages/Candidature/CreateSelfKnowledgeQuestionnairePage";
import ViewSelfKnowledgeQuestionnairePage from "./pages/Candidature/ViewSelfKnowledgeQuestionnairePage";
import ForgotPasswordPage from "./pages/Home/ForgotPasswordPage";
import EnrollmentOfficerPage from "./pages/Candidature/EnrollmentOfficerPage";
import CandidaturesByDistrictPage from "./pages/Candidature/CandidaturesByDistrictPage";
import UpdateBusinessPlanPage from "./pages/BusinessPlan/UpdateBusinessPlanPage";
import ViewBusinessPlanPage from "./pages/BusinessPlan/ViewBusinessPlanPage";
import ListBusinessPlansPage from "./pages/BusinessPlan/ListBusinessPlansPage";
import CreateBusinessPlanPage from "./pages/BusinessPlan/CreateBusinessPlanPage";
import BusinessPlanJuryPanelPage from "./pages/BusinessPlan/BusinessPlanJuryPanelPage";
import BusinessPlanEvaluationPage from "./pages/BusinessPlan/BusinessPlanEvaluationPage";
import JuryBusinessPlanPage from "./pages/BusinessPlan/JuryBusinessPlanPage";
import ScoreBusinessPlanPage from "./pages/BusinessPlan/ScoreBusinessPlanPage";
import BusinessPlanRankingPage from "./pages/BusinessPlan/BusinessPlanRankingPage";
import RecoverAccountPage from "./pages/User/RecoverAccountPage";
import AuthDetailsPage from "./pages/User/AuthDetailsPage";
import WindowEligibilityPage from "./pages/WindowEligibility/WindowEligibilityPage";
import SubmissionPeriodPage from "./pages/SubmissionPeriod/SubmissionPeriodPage";
import ReportsPage from "./pages/Reports/ReportsPage";

function App() {
  return (
    <>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<PublicLayout />}>
            <Route path="/" element={<HomePage />}></Route>
            <Route path="adm" element={<LoginPage />} />
            <Route path="regista-te" element={<SignupPage />} />
            <Route path="esqueceu-a-senha" element={<ForgotPasswordPage />} />
            <Route path="recuperar-conta" element={<RecoverAccountPage />} />
            <Route path="detalhes-conta" element={<AuthDetailsPage />} />
          </Route>
          <Route path="/admin/*" element={<AdminLayout />}>
            <Route path="home" element={<CompetitorDashboardPage />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route
              path="create-candidature"
              element={<CreateCandidaturePage />}
            />
            <Route path="candidature/:uuid" element={<ViewCandidaturePage />} />
            <Route
              path="update-candidature/:uuid"
              element={<UpdateCandidaturePage />}
            />
            <Route
              path="create-self-knowledge-questionnaire/:uuid"
              element={<CreateSelfKnowledgeQuestionnairePage />}
            />
            <Route
              path="self-knowledge-questionnaire/:uuid"
              element={<ViewSelfKnowledgeQuestionnairePage />}
            />
            <Route
              path="submitted-candidature/:uuid"
              element={<SubmittedCandidaturePage />}
            />
            <Route path="candidatures" element={<ListCandidaturesPage />} />
            <Route
              path="enrollment-officers"
              element={<EnrollmentOfficerPage />}
            />
            <Route
              path="candidatures-by-district"
              element={<CandidaturesByDistrictPage />}
            />
            <Route
              path="planos-de-negocio"
              element={<ListBusinessPlansPage />}
            />
            <Route
              path="registar-plano-de-negocio"
              element={<CreateBusinessPlanPage />}
            />
            <Route
              path="editar-plano-de-negocio/:uuid"
              element={<UpdateBusinessPlanPage />}
            />
            <Route
              path="plano-de-negocio/:uuid"
              element={<ViewBusinessPlanPage />}
            />
            <Route
              path="painel-de-juri-planos-de-negocio"
              element={<BusinessPlanJuryPanelPage />}
            />
            <Route
              path="planos-de-negocio-do-juri"
              element={<BusinessPlanEvaluationPage />}
            />
            <Route
              path="plano-de-negocio-juri/:uuid"
              element={<JuryBusinessPlanPage />}
            />
            <Route
              path="pontuar-plano-de-negocio/:uuid"
              element={<ScoreBusinessPlanPage />}
            />
            <Route
              path="ranking-de-planos-de-negocio"
              element={<BusinessPlanRankingPage />}
            />
            <Route
              path="window2-elegibilidade"
              element={<WindowEligibilityPage />}
            />
            <Route
              path="periodos-de-submissao"
              element={<SubmissionPeriodPage />}
            />
            <Route path="relatorios" element={<ReportsPage />} />
            <Route path="utilizadores" element={<UsersPage />} />
            <Route path="registar-utilizador" element={<CreateUserPage />} />
            <Route
              path="actualizar-utilizador/:username"
              element={<UpdateUserPage />}
            />
            <Route path="minha-conta" element={<UserProfilePage />} />
          </Route>
          <Route path="*" element={<NotFoudPage />} />
        </Routes>
      </AuthProvider>
    </>
  );
}

export default App;
